import { TonConnectUIProvider } from "@tonconnect/ui-react";
import { AuthLayout } from "../layouts/auth-layout";
import { ActiveEsimProvider } from "../../src/shared/hooks";
import { TONESIM_TON_CONNECT_ACTIONS } from "../../src/shared/config/ton-connect";
import { WalletLifecycleManager } from "./wallet-lifecycle-manager";

interface AuthLayoutWithTonConnectProps {
  children: React.ReactNode;
  manifestUrl: string;
}

/**
 * Combines AuthLayout with TonConnect provider and wallet management.
 * This is the main authenticated app wrapper.
 */
export function AuthLayoutWithTonConnect({
  children,
  manifestUrl,
}: AuthLayoutWithTonConnectProps) {
  return (
    <AuthLayout>
      <TonConnectUIProvider
        actionsConfiguration={TONESIM_TON_CONNECT_ACTIONS}
        manifestUrl={manifestUrl}
      >
        <ActiveEsimProvider>
          <WalletLifecycleManager />
          {children}
        </ActiveEsimProvider>
      </TonConnectUIProvider>
    </AuthLayout>
  );
}

